<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="ClassId"
      ref="list"
      unit="故障类型"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="false"
      :get-data-func="getData"
      urlHash="facility/failuretype"
      :showTrendTable="showTrendTable"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'
// import tableColumn from "@/data/facility/type/list.json";
// import tableParam from "@/data/basedata/personnel/job/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/ba/class').default,
      params: {
        ClassId: '',
        ClassType: 18
      }
    }
  },
  props: {
    showTrendTable: {
      type: Boolean,
      default: true
    }
  },
  mounted(){
    this.$refs.list.showTable=true;
    this.$refs.list.query();
  },
  methods: {
    getData() {
      return new Promise((resolve, reject) => {
        this.api.list(this.params).then(res => {   
            resolve(res);
        })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      })
    },
    delRange(ids) {
      this.api.delete({ ids }).then(res => {
        if (res.Code == 0) {
          this.$message.success('删除成功')
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  }
}
</script>